import { useMemo } from "react";
import {
  AdminPermissions,
  buildAdminPermissions,
} from "../admin/entities/AdminRole";
import { useAdminStore } from "../store/adminStore";
import { useTrainingRoute } from "./useTrainingRoute";

export function useAdminPermissions(): AdminPermissions {
  const { trainingId } = useTrainingRoute();
  const role = useAdminStore((state) => {
    if (!trainingId) return null;
    const assignment = state.adminTrainings.find(
      (entry) => entry.trainingId === String(trainingId),
    );
    return assignment?.role ?? null;
  });

  return useMemo(() => buildAdminPermissions(role), [role]);
}
